import { render, staticRenderFns } from "./InternalComponents.vue?vue&type=template&id=3248a173&"
import script from "./InternalComponents.vue?vue&type=script&lang=js&"
export * from "./InternalComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3248a173')) {
      api.createRecord('3248a173', component.options)
    } else {
      api.reload('3248a173', component.options)
    }
    module.hot.accept("./InternalComponents.vue?vue&type=template&id=3248a173&", function () {
      api.rerender('3248a173', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/configuration/InternalComponents.vue"
export default component.exports